import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import loader from "../../assets/Images/loader.gif";
// import DateTime from "react-datetime";
// import "react-datetime/css/react-datetime.css";
import { StyledEngineProvider } from "@mui/material/styles";
import dayjs from "dayjs";
import { DemoContainer , DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
// import moment from 'moment';

const optionDncNumber = [
  { value: "0", label: "Select Option" },
  { value: "111260001", label: "Yes" },
  { value: "111260000", label: "No" },
];
const optionLeadChannel = [
  { label: "Select Channel", value: "" },
  { label: "CXM Team", value: "CXM Team" },
  { label: "Call/SMS-Inbound", value: "Call/SMS-Inbound" },
  { label: "Caretel", value: "Caretel" },
  { label: "CM Outbound", value: "CM Outbound" },
  { label: "Email/Email Campaigns", value: "Email/Email Campaigns" },
  { label: "Inside Sales", value: "Inside Sales" },
  { label: "Inside Sales-QC", value: "Inside Sales-QC" },
  { label: "FFA APP", value: "FFA APP" },
  { label: "NetOps Channel", value: "NetOps Channel" },
  { label: "Online CAF", value: "Online CAF" },
  { label: "Outbound Call", value: "Outbound Call" },
  { label: "Paid Campaign/Activity", value: "Paid Campaign/Activity" },
  {
    label: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
    value: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
  },
  { label: "Self Care Portal", value: "Self Care Portal" },
  { label: "Self Lead", value: "Self Lead" },
  { label: "Unify Churned", value: "Unify Churned" },
  { label: "Web Campaign", value: "Web Campaign" },
];
// const optionLeadChannel = ["Select Channel", "one", "two"];
// const optionLeadSource = [{ value: "", label: "Select Option" }];
const optionProductCategory = [
  { value: "", label: "Select Option" },
  { value: "AI.VIS", label: "AI.VIS" },
  { value: "BIA", label: "BIA" },
  { value: "DIA", label: "DIA" },
  { value: "Cloud", label: "Cloud" },
  { value: "Manage Router", label: "Manage Router" },
  { value: "Manage Wi-Fi", label: "Manage Wi-Fi" },
  { value: "Managed Firewall", label: "Managed Firewall" },
  { value: "Managed Wifi Infra", label: "Managed Wifi Infra" },
  { value: "MBB", label: "MBB" },
  { value: "MBIA", label: "MBIA" },
  { value: "SDWAN", label: "SDWAN" },
  { value: "SIP-Trunk", label: "SIP-Trunk" },
  { value: "VOIP", label: "VOIP" },
];
const optionStatusReason = [
  { value: "0", label: "Select Option" },
  // { value: "111260001", label: "Closed" },
  { value: "111260007", label: "Closed" },
  { value: "111260000", label: "Scheduled for Appointment" },
  { value: "111260002", label: "Lead Created/Closed" },
];

const optionDisposition = [
  { value: "0", label: "Select Option" },
  { value: "569480000", label: "Busy" },
  { value: "569480001", label: "Call Back" },
  { value: "569480002", label: "Call Drop" },
  { value: "569480003", label: "Call To Sales Rep." },
  { value: "569480004", label: "Duplicate" },
  { value: "569480007", label: "Existing Customer" },
  { value: "569480008", label: "Follow Up" },
  { value: "569480009", label: "Hung Up" },
  { value: "569480010", label: "Invalid No." },
  { value: "569480011", label: "Landline Issue" },
  { value: "569480012", label: "Language Barrier" },
  { value: "569480014", label: "Lead Business" },
  { value: "569480015", label: "Lead Home" },
  { value: "569480016", label: "Location is Non RFS" },
  { value: "111260000", label: "Lost To Competition" },
  { value: "111260001", label: "No Voice" },
  { value: "111260002", label: "Not Interested" },
  { value: "111260003", label: "Not Looking For Services" },
  { value: "111260004", label: "Not Reachable" },
  { value: "111260005", label: "Nurture" },
  { value: "111260006", label: "Online Payment Done" },
  { value: "111260007", label: "Plan Expensive" },
  { value: "111260008", label: "Pre Lead Generated" },
  { value: "111260009", label: "Ringing" },
  { value: "111260010", label: "Service Related Follow up" },
  { value: "111260011", label: "Switched Off" },
  { value: "111260012", label: "Test Call" },
  { value: "111260013", label: "Using Other ISP" },
  { value: "111260014", label: "Wrong No" },
  { value: "111260015", label: "SMS Sent" },
  { value: "111260016", label: "E-Mail Sent" },
  { value: "111260017", label: "N/A" },
];
const optionCompetitorName = [
  { value: "", label: "Select Option" },
  { value: "ACT Fibernet", label: "ACT Fibernet" },
  { value: "ADTL", label: "ADTL" },
  { value: "Aircel", label: "Aircel" },
  { value: "Airtel", label: "Airtel" },
  { value: "BSNL", label: "BSNL" },
  { value: "Hathway", label: "Hathway" },
  { value: "Jio", label: "Jio" },
  { value: "MTNL", label: "MTNL" },
  { value: "N.A", label: "N.A" },
  { value: "new com", label: "new com" },
  { value: "Nextra", label: "Nextra" },
  { value: "Others", label: "Others" },
  { value: "Reliance Communications", label: "Reliance Communications" },
  { value: "Sify", label: "Sify" },
  { value: "Tata Communications", label: "Tata Communications" },
  { value: "Tata DOCOMO", label: "Tata DOCOMO" },
  { value: "Tikona Infinet", label: "Tikona Infinet" },
  { value: "Vodafone", label: "Vodafone" },
];
const optionIndustrySegment = [
  { value: "Others", label: "Others" },
  { value: "PG", label: "PG" },
];
const optionState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Jharkhand", code: "100030" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const optionPgWifiBill = [
  { value: "", label: "Select Option" },
  { value: "Less than 10000", label: "Less than 10000" },
  { value: "10000 to 15000", label: "10000 to 15000" },
  { value: "15000 to 20000", label: "15000 to 20000" },
  { value: "20000 to 25000", label: "20000 to 25000" },
  { value: "More than 25000", label: "More than 25000" },
];
const optionPgCamera = [
  { value: "", label: "Select Option" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];
const optionPgCategory = [
  { value: "", label: "Select Option" },
  { value: "Boys PG", label: "Boys PG" },
  { value: "Girls PG", label: "Girls PG" },
  { value: "Service Apartment", label: "Service Apartment" },
  { value: "Co-Living", label: "Co-Living" },
];
const optionPgSolution = [
  { value: "", label: "Select Option" },
  { value: "Hot Lead", label: "Hot Lead" },
  { value: "Warm Lead", label: "Warm Lead" },
  { value: "Cold Lead", label: "Cold Lead" },
  { value: "Not Interested", label: "Not Interested" },
];

const ContactsManagementForm = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
    inputFocused: {
      boxShadow: "none",
      fontSize: "14px",
    },
  };

  const [activeForm, setActiveForm] = useState("form1");
  const [userData, setUserData] = useState({
    fullName: "",
    firstName: "",
    lastName: "",
    mobileOne: "",
    mobileTwo: "",
    email: "",
    campaignName: "",
    otp: "",
    specificBuilding: "",
    specificArea: "",
    remark: "",
    pgName: "",
    pgOwner: "",
    pgContactNum: "",
    howManyPg: "",
    pgAddress: "",
    pgAreaName: "",
    NumOfPgFloor: "",
    NumOfPgRoom: "",
    NumOfPgBed: "",
    currentWifiOperator: "",
    NumOfPgBroadband: "",
    dateOfRecharge: "",
    serviceExpect: "",
    changeReason: "",
    specifyLeadSource : ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectDNCno, setSelectDNCno] = useState(optionDncNumber[0]);
  const [selectLeadChannel, setSelectLeadChannel] = useState(
    optionLeadChannel[0]
  );
  const [selectLeadSource, setSelectLeadSource] = useState();
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [selectProductCategory, setSelectProductCategory] = useState(
    optionProductCategory[0]
  );
  const [selectStatusReason, setSelectStatusReason] = useState(
    optionStatusReason[0]
  );
  const [checkStatusReason, setCheckStatusReason] = useState("");
  const [selectDisposition, setSelectDisposition] = useState(
    optionDisposition[0]
  );
  const [selectCompetitorName, setSelectCompetitorName] = useState(
    optionCompetitorName[0]
  );
  const [selectIndustrySegment, setSelectIndustrySegment] = useState(
    optionIndustrySegment[0]
  );
  const [selectCity, setSelectCity] = useState("");
  const [cityType, setCityType] = useState([]);
  const [selectState, setSelectState] = useState("");
  const [areaList, setAreaList] = useState([]);
  const [selectArea, setSelectArea] = useState("");
  const [buildingList, setBuildingList] = useState([]);
  const [selectBuilding, setSelectBuilding] = useState("");
  const [selectPgCategory, setSelectPgCategory] = useState(optionPgCategory[0]);
  const [selectPgWifiBill, setSelectPgWifiBill] = useState(optionPgWifiBill[0]);
  const [selectPgCamera, setSelectPgCamera] = useState(optionPgCamera[0]);
  const [selectPgSolution, setSelectPgSolution] = useState(optionPgSolution[0]);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [fieldsEditable, setFieldsEditable] = useState(true);
  const [otpContactStatus, setOtpContactStatus] = useState("");
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  // const [cityCode , setCityCode]=useState("");
  // const [cityName , setCityName]=useState("");

  const handleChange = (e) => {
    // console.log(e.target.name);
    // console.log(e.target.value);
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSelectDNC = (selectDNC) => {
    setSelectDNCno(selectDNC);
  };
  const handleSelectLead = (selectLead) => {
    setSelectLeadChannel(selectLead);
  };
  const handleSelectLeadSource = (selectLeadSource) => {
    setSelectLeadSource(selectLeadSource);
  };
  const handleSelectProductCategory = (selectProductCategory) => {
    setSelectProductCategory(selectProductCategory);
  };
  const handleSelectStatusReason = (selectStatusReason) => {
    setSelectStatusReason(selectStatusReason);
  };
  const handleSelectDisposition = (selectDisposition) => {
    setSelectDisposition(selectDisposition);
  };
  const handleSelectCompetitorName = (selectCompetitorName) => {
    setSelectCompetitorName(selectCompetitorName);
  };
  const handleSelectIndustrySegment = (selectIndustrySegment) => {
    setSelectIndustrySegment(selectIndustrySegment);
  };
  const handleSelectPgCategory = (selectPgCategory) => {
    setSelectPgCategory(selectPgCategory);
  };
  const handleSelectWifiBill = (selectWifiBill) => {
    setSelectPgWifiBill(selectWifiBill);
  };
  const handleSelectPgCamera = (selectPgCamera) => {
    setSelectPgCamera(selectPgCamera);
  };
  const handleSelectPgSolution = (selectPgSolution) => {
    setSelectPgSolution(selectPgSolution);
  };

  const handleSelectCity = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    // console.log("selectedCityCode", selectedOption.value);
    // console.log("selectedCityName", selectedOption.label);
    setSelectCity(selectedOption);
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL;
      const areaRequestBody = {
        Action: "getArea",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem("password"),
        restrictedarea: false,
        stateCode: "",
        userName: sessionStorage.getItem("userName"),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response.Data)) {
        // console.log("area :", areaData.Response.Data);
        setAreaList(areaData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectState = (selectedState) => {
    setSelectState(selectedState);
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem("password"),
          stateCode: selectState.value,
          userName: sessionStorage.getItem("userName"),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          setCityType(cityData.Response.Data);
        } else {
          // console.error("City data structure not recognized:",cityData.Response);
          // setCityType([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    // fetchCities();
    // Fetch cities only if a state is selected
    if (selectState) {
      fetchCities();
    }
  }, [selectState]);

  // useEffect(() => {
  //   const fetchCities = async () => {
  //     try {
  //       // City API call
  //       const cityApiUrl = "https://ffamwapi.spectra.co/index.php";
  //       const cityRequestBody = {
  //         Action: "getCity",
  //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         password: sessionStorage.getItem("password"),
  //         stateCode: selectState.value,
  //         userName: sessionStorage.getItem("userName"),
  //       };
  //       const cityResponse = await fetch(cityApiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(cityRequestBody),
  //       });
  //       const cityData = await cityResponse.json();
  //       if (cityData.Response && Array.isArray(cityData.Response.Data) && cityData.Response.Data.length > 0) {
  //         setCityType(cityData.Response.Data);
  //         console.log("City Data:", cityData.Response.Data);

  //         console.log("selectCity.label:", selectCity.label);
  //         // Extract city code and name here and store in state
  //         const selectedCity = cityData.Response.Data.find(city => city.CityName === selectCity.label);
  //         console.log("selectedCity", selectedCity);
  //         if (selectedCity) {
  //           setCityCode(selectedCity.CityCode);
  //           setCityName(selectedCity.CityName);
  //         }
  //       } else {
  //         // Handle case where city data structure is not recognized or empty
  //         console.error("City data structure not recognized or empty:", cityData.Response);
  //         // setCityType([]);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };
  //   fetchCities();
  // }, [selectState, selectCity]);

  // useEffect(() => {
  //     const fetchAreaData = async () => {
  //       try {
  //         const areaApiUrl = "https://ffamwapi.spectra.co/index.php";
  //         const areaRequestBody = {
  //           Action: "getArea",
  //           Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //           cityCode: cityCode,
  //           cityName: cityName,
  //           password: "Target@2021#@",
  //           restrictedarea: false,
  //           stateCode: "",
  //           userName: "manager1",
  //         };
  //         const areaResponse = await fetch(areaApiUrl, {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(areaRequestBody),
  //         });
  //         const areaData = await areaResponse.json();
  //         if (areaData.Response && Array.isArray(areaData.Response.Data)) {
  //           console.log("Area Data:", areaData.Response.Data);
  //           setAreaList(areaData.Response.Data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching area data:", error);
  //       }
  //     };
  //     fetchAreaData();
  //     // if (cityCode && cityName) {
  //     //   fetchAreaData();
  //     // }
  //   }, [cityCode, cityName]);

  const handleSelectArea = async (selectedOption) => {
    setSelectArea(selectedOption);
    const areaCode = selectedOption.value;
    const areaName = selectedOption.label.split(" ")[0];
    try {
      const buildingApiUrl = process.env.REACT_APP_API_URL;
      const buildingRequestBody = {
        Action: "getBuilding",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        areaCode: areaCode,
        areaName: areaName,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const buildingResponse = await fetch(buildingApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(buildingRequestBody),
      });
      const buildingData = await buildingResponse.json();
      if (buildingData.Response && Array.isArray(buildingData.Response.Data)) {
        setBuildingList(buildingData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching building data:", error);
    }
  };

  const handleSendOtp = async (email, mobileNo) => {
    // console.log("Button clicked");
    if (!userData.mobileOne) {
      toast.warning("Please Enter Customer Contact Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)
    ) {
      toast.warning("Please Enter Customer Email Id", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else {
      try {
        setIsLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const otpRequestBody = {
          Action: "sendOTPContact",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          mobileNo: mobileNo,
          preOTP: "",
          userEmail: email,
        };
        const otpResponse = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(otpRequestBody),
        });
        const sendOtpData = await otpResponse.json();
        // console.log("send otp :",sendOtpData)
        if (sendOtpData.Status === "Success") {
          // console.log("send otp :",sendOtpData.Status)
          toast.success("OTP Send Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          setOtpSent(true);
          setOtp(sendOtpData.Response);
          setIsLoading(false);
          // console.log("sendOtpData.Response :", sendOtpData.Response);
        } else {
          // console.error('Failed to send OTP:', otpResponse.statusText);
          toast.warning(otpResponse.statusText, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error sending OTP:", error);
      }
    }
  };

  const handleVerifyOtp = () => {
    const otpValue = String(otp).trim();
    const customerOtpValue = userData.otp.trim();
    // console.log("userData.otp :",customerData.otp);
    // console.log("otp :",otp);
    setIsLoading(true);
    if (otpValue === customerOtpValue) {
      toast.success("OTP verified Successfully", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      setOtpContactStatus("111260000");
      setFieldsEditable(false);
      setIsLoading(false);
    } else {
      toast.warning("Incorrect OTP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      setOtpContactStatus("111260001");
      setIsLoading(false);
    }
  };

  const handleResendOtp = async (email, mobileNo) => {
    const otpValue = String(otp).trim();
    try {
      setIsLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const otpRequestBody = {
        Action: "sendOTPContact",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        mobileNo: mobileNo,
        preOTP: otpValue,
        userEmail: email,
      };
      const otpResponse = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(otpRequestBody),
      });
      const resendOtpData = await otpResponse.json();
      // console.log("resend otp :", resendOtpData);
      if (resendOtpData.Status === "Success") {
        // console.log("send otp :",resendOtpData.Status)
        toast.success("OTP Resend Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false);
        // setFieldsEditable(false);
        // setOtpSent(true);
        // setOtp(sendOtpData.Response);
        // console.log("sendOtpData.Response :",sendOtpData.Response)
      } else {
        toast.warning(otpResponse.statusText || "Failed to send OTP", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const ContactId = searchParams.get("ContactId");
  // console.log("ContactId :", ContactId);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // lead source API call
        const leadSourceApiUrl = process.env.REACT_APP_API_URL;
        const leadSourceRequestBody = {
          Action: "getSource",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          channelName: selectLeadChannel.value,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const leadSourceResponse = await fetch(leadSourceApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(leadSourceRequestBody),
        });
        const leadSourceData = await leadSourceResponse.json();
        // console.log("lead Source :", leadSourceData.Response.Data);
        // Check if data is not undefined or null before mapping
        if (leadSourceData.Response.Data) {
          // Transforming data into the required format
          const transformedOptions = leadSourceData.Response.Data.map(
            (option) => ({
              label: option.SourceName,
              value: option.SourceName,
            })
          );
          // console.log("setLeadSourceOptions",transformedOptions)
          setLeadSourceOptions(transformedOptions);
          if (!ContactId && transformedOptions.length > 0) {
            setSelectLeadSource(transformedOptions[0]);
          }
        } else {
          // If data is undefined or null, set leadSourceOptions to an empty array
          setLeadSourceOptions([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [selectLeadChannel, ContactId]);

  // Get the current date and time
  const currentDate = new Date();
  // Extract individual components
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1; // Note: Months are zero-based (0-January, 1-February, etc.)
  const date = currentDate.getDate();
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const seconds = currentDate.getSeconds();
  // Format the date and time as a string
  const formattedDateTime = `${year}-${month < 10 ? "0" + month : month}-${
    date < 10 ? "0" + date : date
  } ${hours < 10 ? "0" + hours : hours}:${
    minutes < 10 ? "0" + minutes : minutes
  }:${seconds < 10 ? "0" + seconds : seconds}`;
  // console.log("Current Date and Time:", formattedDateTime);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
          Action: "getContact",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          contactID: ContactId,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        // console.log("getContact", data);
        // console.log("FollowupDate :",data.Response.Data[0].FollowupDate)
        setUserData({
          fullName: data.Response.Data[0].FullName,
          firstName: data.Response.Data[0].FirstName,
          lastName: data.Response.Data[0].LastName,
          mobileOne: data.Response.Data[0].MobileNumber,
          mobileTwo: data.Response.Data[0].MobileNumber2,
          email: data.Response.Data[0].EmailAddress,
          campaignName: data.Response.Data[0].CampaignName,
          specificBuilding: data.Response.Data[0].Specifybuilding,
          specificArea: data.Response.Data[0].SpecifyArea,
          remark: data.Response.Data[0].Remark,
        });
        setSelectDNCno({
          value: data.Response.Data[0].DncNumber,
          label: data.Response.Data[0].DncNumber,
        });
        setSelectLeadChannel({
          value: data.Response.Data[0].Channel,
          label: data.Response.Data[0].Channel,
        });
        setSelectLeadSource({
          value: data.Response.Data[0].Source,
          label: data.Response.Data[0].Source,
        });
        setSelectProductCategory({
          value: data.Response.Data[0].PlanCategory,
          label: data.Response.Data[0].PlanCategory,
        });
        setSelectStatusReason({
          value: data.Response.Data[0].StatusReason,
          label: data.Response.Data[0].StatusReason,
        });
        setCheckStatusReason(data.Response.Data[0].StatusReason);
        setSelectDisposition({
          value: data.Response.Data[0].Disposition,
          label: data.Response.Data[0].Disposition,
        });
        setSelectCompetitorName({
          value: data.Response.Data[0].CompetitorName,
          label: data.Response.Data[0].CompetitorName,
        });
        // setSelectIndustrySegment({
        //   value: data.Response.Data[0].IndustryTypeId,
        //   label: data.Response.Data[0].IndustryTypeId,
        // })
        let getdate = data.Response.Data[0].FollowupDate;
        let changeFormatDate  = dayjs(getdate, "DD-MM-YYYY HH:mm:ss")
        // console.log("changeFormatDate",changeFormatDate);
        setSelectedDateTime(changeFormatDate);

        const filterState = optionState.find(
          (item) => item.name === data.Response.Data[0].State
        )?.code;
        // console.log("filterState",filterState)
        setSelectState({
          value: filterState,
          label: data.Response.Data[0].State,
        });
        setSelectCity({
          value: data.Response.Data[0].CityId,
          label: data.Response.Data[0].City,
        });
        setSelectArea({
          value: data.Response.Data[0].AreaId,
          label: `${data.Response.Data[0].Area} (${data.Response.Data[0].AreaId})`,
        });
        setSelectBuilding({
          value: data.Response.Data[0].BuildingId,
          label: `${data.Response.Data[0].Building} (${data.Response.Data[0].BuildingId})`,
        });
      } catch (error) {
        //console.error("Error fetching data:", error);
        toast.warning(error, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 500,
        });
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [ContactId]);

  const handleSubmit = async () => {
    if (!userData.firstName) {
      toast.warning("Please Enter First Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (!userData.lastName) {
      toast.warning("Please Enter Last Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (!userData.mobileOne || userData.mobileOne.length < 10) {
      toast.warning("Please Enter Mobile Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)
    ) {
      toast.warning("Please Enter Email Address", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (!selectLeadChannel.value) {
      toast.warning("Please Select Lead Channel", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (!selectProductCategory.value) {
      toast.warning("Please Select Product Category", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (selectStatusReason.value === "0") {
      toast.warning("Please Select Status Reason", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (selectDisposition.value === "0") {
      toast.warning("Please Select Disposition", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (!selectCompetitorName.value) {
      toast.warning("Please Select Competitor Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (!selectState) {
      toast.warning("Please Select State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (!selectCity) {
      toast.warning("Please  Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (!selectArea) {
      toast.warning("Please  Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else if (!selectBuilding) {
      toast.warning("Please  Select Building", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    } else {
      if (selectIndustrySegment.value === "PG") {
        if (!userData.pgName) {
          toast.warning("Please Enter PG Name", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.pgOwner) {
          toast.warning("Please Enter PG Owner Name", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.pgContactNum) {
          toast.warning("Please Enter PG Contact Number", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
        else if (userData.pgContactNum.length < 10) {
          toast.warning("Please Enter PG Contact Number", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
         else if (!userData.howManyPg) {
          toast.warning("Please Enter How Many PG's Does this Owner have", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.pgAddress) {
          toast.warning("Please Enter PG Address with landmark", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.pgAreaName) {
          toast.warning("Please Enter Area Name", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.NumOfPgFloor) {
          toast.warning("Please Enter Number of Floors in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.NumOfPgRoom) {
          toast.warning("Please Enter Number of Rooms in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.NumOfPgBed) {
          toast.warning("Please Enter Number of Beds in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.currentWifiOperator) {
          toast.warning("Please Enter Current Wifi Operator in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.NumOfPgBroadband) {
          toast.warning("Please Enter Number of Broadband connections used", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } 
        else if (selectPgWifiBill.value == "") {
          toast.warning("Please Select Average Monthly Spent on wifi bill", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }else if (!userData.dateOfRecharge) {
          toast.warning(
            "Please Enter Date of Recharge of existing connections",
            {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            }
          );
        }  else if (selectPgCategory.value == "") {
          toast.warning("Please Select Category of PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (selectPgCamera.value == "") {
          toast.warning("Please Select CCTV Camera Available in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.serviceExpect) {
          toast.warning("Please Enter Service Expectations from the Operator", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!userData.changeReason) {
          toast.warning("Please Enter Reason to Change the Current operator", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
        else if (selectPgSolution.value == "") {
          toast.warning("Please Select Interested in Spectra PG Solution", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else {
          if (ContactId) {
            setIsLoading(true);
            let dncNum;
            // let reasonStatus;
            let dispositionValue;
            const contactUpdateUrl = process.env.REACT_APP_API_URL;
            if (selectDNCno.value === "Yes") {
              dncNum = "111260001";
            } else if (selectDNCno.value === "No") {
              dncNum = "111260000";
            }
            // if (selectStatusReason.value === "Closed") {
            //   reasonStatus = "111260001";
            // } else if (
            //   selectStatusReason.value === "Scheduled for Appointment"
            // ) {
            //   reasonStatus = "111260000";
            // } else if (selectStatusReason.value === "Lead Created/Closed") {
            //   reasonStatus = "111260002";
            // }

            const statusMap = {
              'Closed': '111260001',
              'Scheduled for Appointment': '111260000',
              'Lead Created/Closed': '111260002'
            };
            const reasonStatus = statusMap[selectStatusReason.label] || null;

            if (selectDisposition.value === "Busy") {
              dispositionValue = "569480000";
            } else if (selectDisposition.value === "Call Back") {
              dispositionValue = "569480001";
            } else if (selectDisposition.value === "Call Drop") {
              dispositionValue = "569480002";
            } else if (selectDisposition.value === "Call To Sales Rep.") {
              dispositionValue = "569480003";
            } else if (selectDisposition.value === "Duplicate") {
              dispositionValue = "569480004";
            } else if (selectDisposition.value === "Existing Customer") {
              dispositionValue = "569480007";
            } else if (selectDisposition.value === "Follow Up") {
              dispositionValue = "569480008";
            } else if (selectDisposition.value === "Hung Up") {
              dispositionValue = "569480009";
            } else if (selectDisposition.value === "Invalid No.") {
              dispositionValue = "569480010";
            } else if (selectDisposition.value === "Landline Issue") {
              dispositionValue = "569480011";
            } else if (selectDisposition.value === "Language Barrier") {
              dispositionValue = "569480012";
            } else if (selectDisposition.value === "Lead Business") {
              dispositionValue = "569480014";
            } else if (selectDisposition.value === "Lead Home") {
              dispositionValue = "569480015";
            } else if (selectDisposition.value === "Location is Non RFS") {
              dispositionValue = "569480016";
            } else if (selectDisposition.value === "Lost To Competition") {
              dispositionValue = "111260000";
            } else if (selectDisposition.value === "No Voice") {
              dispositionValue = "111260001";
            } else if (selectDisposition.value === "Not Interested") {
              dispositionValue = "111260002";
            } else if (selectDisposition.value === "Not Looking For Services") {
              dispositionValue = "111260003";
            } else if (selectDisposition.value === "Not Reachable") {
              dispositionValue = "111260004";
            } else if (selectDisposition.value === "Nurture") {
              dispositionValue = "111260005";
            } else if (selectDisposition.value === "Online Payment Done") {
              dispositionValue = "111260006";
            } else if (selectDisposition.value === "Plan Expensive") {
              dispositionValue = "111260007";
            } else if (selectDisposition.value === "Pre Lead Generated") {
              dispositionValue = "111260008";
            } else if (selectDisposition.value === "Ringing") {
              dispositionValue = "111260009";
            } else if (
              selectDisposition.value === "Service Related Follow up"
            ) {
              dispositionValue = "111260010";
            } else if (selectDisposition.value === "Switched Off") {
              dispositionValue = "111260011";
            } else if (selectDisposition.value === "Test Call") {
              dispositionValue = "111260012";
            } else if (selectDisposition.value === "Using Other ISP") {
              dispositionValue = "111260013";
            } else if (selectDisposition.value === "Wrong No") {
              dispositionValue = "111260014";
            } else if (selectDisposition.value === "SMS Sent") {
              dispositionValue = "111260015";
            } else if (selectDisposition.value === "E-Mail Sent") {
              dispositionValue = "111260016";
            } else if (selectDisposition.value === "N/A") {
              dispositionValue = "111260017";
            }

            if(selectArea.label.includes("Other") && !userData.specificArea){
              toast.warning("Please Enter Specific Area name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
              return
            }else if(selectBuilding.label.includes("Other") && !userData.specificBuilding){
              toast.warning("Please Enter Specific Building name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
              return
            }

            // const filterState = optionState.find(
            //   (state) => state.name === selectState.value
            // );
            // var originalDate = moment(selectedDateTime, 'DD-MM-YYYYTHH:mm:ss');
            // var formattedDate = originalDate.format('MM-DD-YYYY HH:mm:ss');
            // console.log("formattedDate",formattedDate);
            const contactUpdationData = {
              Action: "updateContact",
              Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
              area: selectArea.value ? selectArea.value : "",
              building: selectBuilding.value ? selectBuilding.value : "",
              businessSegment: "Business",
              callAttempted: "1",
              campaignName: userData.campaignName ? userData.campaignName : "",
              channel: selectLeadChannel.value ? selectLeadChannel.value : "",
              city: selectCity.value ? selectCity.value : "",
              competitorName: selectCompetitorName.value
                ? selectCompetitorName.value
                : "",
              contactId: ContactId ? ContactId : "",
              contactVerificationStatus: otpContactStatus ? otpContactStatus : "",
              // disposition: selectDisposition.value ? dispositionValue : "",
              // dncNumber: selectDNCno.value ? dncNum : "",
              disposition: selectDisposition.value ? selectDisposition.value : "",
              dncNumber: selectDNCno.value ? selectDNCno.value : "",
              emailAddress: userData.email ? userData.email : "",
              firstName: userData.firstName ? userData.firstName : "",
              followupDate: selectedDateTime ? selectedDateTime : "",
              lastName: userData.lastName ? userData.lastName : "",
              mobileNumber: userData.mobileOne ? userData.mobileOne : "",
              mobileNumber2: userData.mobileTwo ? userData.mobileTwo : "",
              password: sessionStorage.getItem("password"),
              planCategory: selectProductCategory.value
                ? selectProductCategory.value
                : "",
              remark:
                `Remarks: ${userData.remark} ; \n` +
                `PG Info: Created By: ${sessionStorage.getItem(
                  "userName"
                )} on ${formattedDateTime} \n` +
                `Name of the PG: ${userData.pgName} \n` +
                `PG Owner Name: ${userData.pgOwner} \n` +
                `PG Contact Number: ${userData.pgContactNum} \n` +
                `How Many PG's Does this Owner have: ${userData.howManyPg} \n` +
                `PG Address with landmark: ${userData.pgAddress} \n` +
                `Area Name: ${userData.pgAreaName} \n` +
                `Number of Floors in the PG: ${userData.NumOfPgFloor} \n` +
                `Number of Rooms in the PG: ${userData.NumOfPgRoom} \n` +
                `Number of Beds in PG: ${userData.NumOfPgBed} \n` +
                `Current Wifi Operator in the PG: ${userData.currentWifiOperator} \n` +
                `Number of Broadband connections used: ${userData.NumOfPgBroadband} \n` +
                `Average Monthly spent on wifi bill: ${selectPgWifiBill.value} \n` +
                `Date of Recharge of existing connections: ${userData.dateOfRecharge} \n` +
                `Category of PG: ${selectPgCategory.value} \n` +
                `CCTV Camera Available in the PG: ${selectPgCamera.value} \n` +
                `Service Expectations from the Operator: ${userData.serviceExpect} \n` +
                `Reason to change the current operator: ${userData.changeReason} \n` +
                `Interested in Spectra PG solution: ${selectPgSolution.value}`,
              society: "",
              source: selectLeadSource.value ? selectLeadSource.value : "",
              specifyArea: userData.specificArea ? userData.specificArea : "",
              specifybuilding: userData.specificBuilding ? userData.specificBuilding : "",
              state: selectState.value ? selectState.value : "",
              statusReason: selectStatusReason.value ? reasonStatus : "",
              userName: sessionStorage.getItem("userName"),
            };
            try {
              const response = await fetch(contactUpdateUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(contactUpdationData),
              });
              // console.log(
              //   "Request Payload:",
              //   JSON.stringify(contactUpdationData)
              // );
              const data = await response.json();
              const lead = data.Response.ContactId;
              // console.log("API Response contact Update:", data);
              // console.log("response " , data.Response);
              if (data.Status === "Success") {
                if(reasonStatus == "111260002"){
                  toast.success("Lead Created Successfully", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                  });
                  navigate(`/businessLeadForm?LeadId=${lead}`);
                  navigate(`/businessLead`);
                }else{
                toast.success(" Contact updated Successfully", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
                navigate("/contactManagement");}
              } 
              else {
                setIsLoading(false);
                toast.warning(data.Response.Message, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
              }
            } catch (error) {
              console.error("Error creating lead:", error);
              toast.error("An error occurred. Please try again later.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            }
            finally{
              setIsLoading(false);
            }
          } else {
            if(selectArea.label.includes("Other") && !userData.specificArea){
              toast.warning("Please Enter Specific Area name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
              return
            }else if(selectBuilding.label.includes("Other") && !userData.specificBuilding){
              toast.warning("Please Enter Specific Building name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
              return
            }

            const oldContactCreateUrl = process.env.REACT_APP_API_URL;
            const oldContactCreationData = {
              Action: "createContact",
              Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
              area: selectArea.value ? selectArea.value : "",
              building: selectBuilding.value ? selectBuilding.value : "",
              businessSegment: "Business",
              callAttempted: "1",
              campaignName: userData.campaignName ? userData.campaignName : "",
              channel: selectLeadChannel.value ? selectLeadChannel.value : "",
              city: selectCity.value ? selectCity.value : "",
              competitorName: selectCompetitorName.value
                ? selectCompetitorName.value
                : "",
              contactId: "",
              contactVerificationStatus: otpContactStatus
                ? otpContactStatus
                : "",
              disposition: selectDisposition.value
                ? selectDisposition.value
                : "",
              dncNumber: selectDNCno.value ? selectDNCno.value : "",
              emailAddress: userData.email ? userData.email : "",
              firstName: userData.firstName ? userData.firstName : "",
              followupDate: selectedDateTime ? selectedDateTime : "",
              lastName: userData.lastName ? userData.lastName : "",
              mobileNumber: userData.mobileOne ? userData.mobileOne : "",
              mobileNumber2: userData.mobileTwo ? userData.mobileTwo : "",
              password: sessionStorage.getItem("password"),
              planCategory: selectProductCategory.value
                ? selectProductCategory.value
                : "",
              remark:
                `Remarks: ${userData.remark} ; \n` +
                `PG Info: Created By: ${sessionStorage.getItem(
                  "userName"
                )} on ${formattedDateTime} \n` +
                `Name of the PG: ${userData.pgName} \n` +
                `PG Owner Name: ${userData.pgOwner} \n` +
                `PG Contact Number: ${userData.pgContactNum} \n` +
                `How Many PG's Does this Owner have: ${userData.howManyPg} \n` +
                `PG Address with landmark: ${userData.pgAddress} \n` +
                `Area Name: ${userData.pgAreaName} \n` +
                `Number of Floors in the PG: ${userData.NumOfPgFloor} \n` +
                `Number of Rooms in the PG: ${userData.NumOfPgRoom} \n` +
                `Number of Beds in PG: ${userData.NumOfPgBed} \n` +
                `Current Wifi Operator in the PG: ${userData.currentWifiOperator} \n` +
                `Number of Broadband connections used: ${userData.NumOfPgBroadband} \n` +
                `Average Monthly spent on wifi bill: ${selectPgWifiBill.value} \n` +
                `Date of Recharge of existing connections: ${userData.dateOfRecharge} \n` +
                `Category of PG: ${selectPgCategory.value} \n` +
                `CCTV Camera Available in the PG: ${selectPgCamera.value} \n` +
                `Service Expectations from the Operator: ${userData.serviceExpect} \n` +
                `Reason to change the current operator: ${userData.changeReason} \n` +
                `Interested in Spectra PG solution: ${selectPgSolution.value}`,
              society: "",
              source: selectLeadSource.value ? selectLeadSource.value : "",
              specifyArea: userData.specificArea ? userData.specificArea : "",
              specifybuilding: userData.specificBuilding
                ? userData.specificBuilding
                : "",
              state: selectState.value ? selectState.value : "",
              statusReason: selectStatusReason.value
                ? selectStatusReason.value
                : "",
              userName: sessionStorage.getItem("userName"),
            };
            try {
              setIsLoading(true);
              const response = await fetch(oldContactCreateUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(oldContactCreationData),
              });
              // console.log(
              //   "Request Payload:",
              //   JSON.stringify(oldContactCreationData)
              // );
              const data = await response.json();
              const lead = data.Response.Lead ;        
              // console.log("API Response contact create:", data);
              // console.log("contact Response", data.Response);
              if (data.Status === "Success") {
                if(selectStatusReason.value == "111260002"){
                  toast.success("Lead created Successfully", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                  });
                  navigate(`/businessLead`);
                }else{
                toast.success("create Contact Successfully", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
                navigate("/contactManagement");}
              } else {
                toast.warning(data.Response.Message, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
              }
            } catch (error) {
              console.error("Error creating lead:", error);
              toast.error("An error occurred. Please try again later.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            }
            finally{
              setIsLoading(false);
            }
          }
        }
      } else {
        if (ContactId) {
          setIsLoading(true);
          let dncNum;
          // let reasonStatus;
          let dispositionValue;
          const contactUpdateUrl = process.env.REACT_APP_API_URL;
          if (selectDNCno.value === "Yes") {
            dncNum = "111260001";
          } else if (selectDNCno.value === "No") {
            dncNum = "111260000";
          }
          // if (selectStatusReason.value === "Closed") {
          //   reasonStatus = "111260001";
          // } else if (selectStatusReason.value === "Scheduled for Appointment") {
          //   reasonStatus = "111260000";
          // } else if (selectStatusReason.value === "Lead Created/Closed") {
          //   reasonStatus = "111260002";
          // }

          const statusMap = {
            'Closed': '111260001',
            'Scheduled for Appointment': '111260000',
            'Lead Created/Closed': '111260002'
          };
          const reasonStatus = statusMap[selectStatusReason.label] || null;

          if (selectDisposition.value === "Busy") {
            dispositionValue = "569480000";
          } else if (selectDisposition.value === "Call Back") {
            dispositionValue = "569480001";
          } else if (selectDisposition.value === "Call Drop") {
            dispositionValue = "569480002";
          } else if (selectDisposition.value === "Call To Sales Rep.") {
            dispositionValue = "569480003";
          } else if (selectDisposition.value === "Duplicate") {
            dispositionValue = "569480004";
          } else if (selectDisposition.value === "Existing Customer") {
            dispositionValue = "569480007";
          } else if (selectDisposition.value === "Follow Up") {
            dispositionValue = "569480008";
          } else if (selectDisposition.value === "Hung Up") {
            dispositionValue = "569480009";
          } else if (selectDisposition.value === "Invalid No.") {
            dispositionValue = "569480010";
          } else if (selectDisposition.value === "Landline Issue") {
            dispositionValue = "569480011";
          } else if (selectDisposition.value === "Language Barrier") {
            dispositionValue = "569480012";
          } else if (selectDisposition.value === "Lead Business") {
            dispositionValue = "569480014";
          } else if (selectDisposition.value === "Lead Home") {
            dispositionValue = "569480015";
          } else if (selectDisposition.value === "Location is Non RFS") {
            dispositionValue = "569480016";
          } else if (selectDisposition.value === "Lost To Competition") {
            dispositionValue = "111260000";
          } else if (selectDisposition.value === "No Voice") {
            dispositionValue = "111260001";
          } else if (selectDisposition.value === "Not Interested") {
            dispositionValue = "111260002";
          } else if (selectDisposition.value === "Not Looking For Services") {
            dispositionValue = "111260003";
          } else if (selectDisposition.value === "Not Reachable") {
            dispositionValue = "111260004";
          } else if (selectDisposition.value === "Nurture") {
            dispositionValue = "111260005";
          } else if (selectDisposition.value === "Online Payment Done") {
            dispositionValue = "111260006";
          } else if (selectDisposition.value === "Plan Expensive") {
            dispositionValue = "111260007";
          } else if (selectDisposition.value === "Pre Lead Generated") {
            dispositionValue = "111260008";
          } else if (selectDisposition.value === "Ringing") {
            dispositionValue = "111260009";
          } else if (selectDisposition.value === "Service Related Follow up") {
            dispositionValue = "111260010";
          } else if (selectDisposition.value === "Switched Off") {
            dispositionValue = "111260011";
          } else if (selectDisposition.value === "Test Call") {
            dispositionValue = "111260012";
          } else if (selectDisposition.value === "Using Other ISP") {
            dispositionValue = "111260013";
          } else if (selectDisposition.value === "Wrong No") {
            dispositionValue = "111260014";
          } else if (selectDisposition.value === "SMS Sent") {
            dispositionValue = "111260015";
          } else if (selectDisposition.value === "E-Mail Sent") {
            dispositionValue = "111260016";
          } else if (selectDisposition.value === "N/A") {
            dispositionValue = "111260017";
          }

          // const filteredArea = areaList.find(
          //   (area) => area.label === selectArea.value
          // );
          // const selectedAreaValue = filteredArea ? filteredArea.value : "";
          // console.log("Selected Area Value:", selectedAreaValue);
          // console.log("areaList:", areaList);

          // const filteredCity = cityType.find(
          //   (city) => city.CityName === selectCity.value
          // );
          // const selectedCityValue = filteredCity ? filteredCity.CityCode : "";
          // console.log("Selected city Value:", selectedCityValue);
          // console.log("cityType:", cityType);

          // const filterState = optionState.find(
          //   (state) => state.name === selectState.value
          // );
          // console.log("filterState", filterState.code);
         
          const contactUpdationData = {
            Action: "updateContact",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            area: selectArea.value ? selectArea.value : "",
            building: selectBuilding.value ? selectBuilding.value : "",
            businessSegment: "Business",
            callAttempted: "1",
            campaignName: userData.campaignName ? userData.campaignName : "",
            channel: selectLeadChannel.value ? selectLeadChannel.value : "",
            city: selectCity.value ? selectCity.value : "",
            competitorName: selectCompetitorName.value
              ? selectCompetitorName.value
              : "",
            contactId: ContactId ? ContactId : "",
            contactVerificationStatus: otpContactStatus ? otpContactStatus : "",
            disposition: selectDisposition.value ? dispositionValue : "",
            dncNumber: selectDNCno.value ? dncNum : "",
            emailAddress: userData.email ? userData.email : "",
            firstName: userData.firstName ? userData.firstName : "",
            followupDate: selectedDateTime ? selectedDateTime : "",
            lastName: userData.lastName ? userData.lastName : "",
            mobileNumber: userData.mobileOne ? userData.mobileOne : "",
            mobileNumber2: userData.mobileTwo ? userData.mobileTwo : "",
            password: sessionStorage.getItem("password"),
            planCategory: selectProductCategory.value
              ? selectProductCategory.value
              : "",
            remark: userData.remark ? userData.remark : "",
            society: "",
            source: selectLeadSource.value ? selectLeadSource.value : "",
            specifyArea: userData.specificArea ? userData.specificArea : "",
            specifybuilding: userData.specificBuilding
              ? userData.specificBuilding
              : "",
            state: selectState.value ? selectState.value : "",
            statusReason: selectStatusReason.value ?  reasonStatus : "",
            userName: sessionStorage.getItem("userName"),
          };
          try {
            setIsLoading(true)
            const response = await fetch(contactUpdateUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(contactUpdationData),
            });
            // console.log(
            //   "Request Payload:",
            //   JSON.stringify(contactUpdationData)
            // );
            const data = await response.json();
            const lead = data.Response.ContactId;
            // console.log("API Response contact Update:", data);
            if (data.Status === "Success") {
              if(reasonStatus == "111260002"){
                toast.success(" Lead Created Successfully", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
                // navigate(`/businessLeadForm?LeadId=${lead}`);
                navigate(`/businessLead`);
              }else{
              toast.success(" Contact updated Successfully", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
              navigate("/contactManagement");}
            } 
            else {
              setIsLoading(false);
              toast.warning(data.Response.Message, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            }
          } catch (error) {
            console.error("Error creating lead:", error);
            toast.error("An error occurred. Please try again later.", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
          finally{
            setIsLoading(false);
          }
        } else {
          if(selectArea.label.includes("Other") && !userData.specificArea){
            toast.warning("Please Enter Specific Area name", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            return
          }else if(selectBuilding.label.includes("Other") && !userData.specificBuilding){
            toast.warning("Please Enter Specific Building name", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            return
          }

          const oldContactCreateUrl = process.env.REACT_APP_API_URL;
          const oldContactCreationData = {
            Action: "createContact",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            area: selectArea.value ? selectArea.value : "",
            building: selectBuilding.value ? selectBuilding.value : "",
            businessSegment: "Business",
            callAttempted: "1",
            campaignName: userData.campaignName ? userData.campaignName : "",
            channel: selectLeadChannel.value ? selectLeadChannel.value : "",
            city: selectCity.value ? selectCity.value : "",
            competitorName: selectCompetitorName.value
              ? selectCompetitorName.value
              : "",
            contactId: "",
            contactVerificationStatus: otpContactStatus ? otpContactStatus : "",
            disposition: selectDisposition.value ? selectDisposition.value : "",
            dncNumber: selectDNCno.value ? selectDNCno.value : "",
            emailAddress: userData.email ? userData.email : "",
            firstName: userData.firstName ? userData.firstName : "",
            followupDate: selectedDateTime ? selectedDateTime : "",
            lastName: userData.lastName ? userData.lastName : "",
            mobileNumber: userData.mobileOne ? userData.mobileOne : "",
            mobileNumber2: userData.mobileTwo ? userData.mobileTwo : "",
            password: sessionStorage.getItem("password"),
            planCategory: selectProductCategory.value
              ? selectProductCategory.value
              : "",
            remark: userData.remark ? userData.remark : "",
            society: "",
            source: selectLeadSource?.value ? selectLeadSource?.value : "",
            specifyArea: userData.specificArea ? userData.specificArea : "",
            specifybuilding: userData.specificBuilding
              ? userData.specificBuilding
              : "",
            state: selectState.value ? selectState.value : "",
            statusReason: selectStatusReason.value
              ? selectStatusReason.value
              : "",
            userName: sessionStorage.getItem("userName"),
          };
          try {
            setIsLoading(true);
            const response = await fetch(oldContactCreateUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(oldContactCreationData),
            });
            // console.log(
            //   "Request Payload :",
            //   JSON.stringify(oldContactCreationData)
            // );
            const data = await response.json();
            const lead = data.Response.StatusName ; 

            const text = data.Response.StatusName;
            const leadId = text.match(/L-\d{2}-\d{4}-\d{6}/);

            if (leadId) {
              // console.log(leadId[0]);  // Output: L-02-2025-281241
            }       
              // console.log("API Response contact create:", data);
              
              // console.log("contact Response", data.Response);
              if (data.Status === "Success") {
                if(selectStatusReason.value == "111260002"){
                  toast.success("Lead Created Successfully", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                  });
                  // navigate(`/businessLeadForm?LeadId=${lead}`);
                  navigate(`/businessLead`);
                }else{
                toast.success("create Contact Successfully", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
                navigate("/contactManagement");}
              } 
            else {
              toast.warning(data.Response.Message, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 500,
              });
            }
          } catch (error) {
            console.error("Error creating lead:", error);
            toast.error("An error occurred. Please try again later.", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
          finally{
            setIsLoading(false);
          }
        }
      }
    }
  };

  const handleFlrCreate = () => {
    navigate(`/businessLeadForm?ContactId=${ContactId}`);
  };

  const handleDateTimeChange = (dateTime) => {
    setSelectedDateTime(dateTime);
    // console.log("setSelectedDateTime :",setSelectedDateTime)
  };

  // const handleIconClick = (formId) => {
  //   if (activeForm !== formId) {
  //     setActiveForm(formId);
  //   }
  // };
  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  const navigate = useNavigate();
  const redirectContactManagement = () => {
    Swal.fire({
      html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
      cancelButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/contactManagement");
      } else {
        if (ContactId) {
          navigate(`/contactsManagementForm?ContactId=${ContactId}`);
        } else {
          navigate("/contactsManagementForm");
        }
      }
    });
  };

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectContactManagement}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          {/* <span className="p-1 m-3">Contact Management</span> */}
          {ContactId ? (
            <span className="p-1 m-3">Update Contact</span>
          ) : (
            <span className="p-1 m-3">Contact Management</span>
          )}
          {/* <span className="flr-createCAf" onClick="">
              FLR/Create CAF
          </span> */}
          {/* {ContactId && checkStatusReason == "Lead Created/Closed" ? (
            <span className="flr-createCAf" onClick={handleFlrCreate}>
              FLR/Create CAF
            </span>
          ) : null} */}
        </div>
      </div>
      {/* ************Header end************ */}

      <div className="container-fluid form-container">
        {isLoading && (
          <div className="loader-wrapper">
            <div className="loader">
              <img src={loader} alt="loading...."></img>
            </div>
          </div>
        )}
        {/* **************Contact Information toggle******************* */}
        <div
          className="contact-toggle"
          onClick={() => handleIconClick("form1")}
        >
          <span className="toggle-text">Contact Information</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form1" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form1"
          >
            {/* *********Contact Information form******** */}
            <form className=" contact-form p-2">
              <div className="input-box form-floating"  style={{ position: "relative", paddingTop: "5px" }}>
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-2" 
                  id="fullName"
                  name="fullName"
                  value={userData.fullName}
                  onChange={handleChange}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "60%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="LeadId mt-2">
                  Full Name
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  value={userData.firstName}
                  onChange={handleChange}
                  disabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  First Name*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="lastName"
                  name="lastName"
                  value={userData.lastName}
                  onChange={handleChange}
                  disabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Last Name*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  maxLength="10"
                  pattern="[0-9]{10}"
                  id="mobileOne"
                  name="mobileOne"
                  disabled={
                    !fieldsEditable ||
                    (ContactId && checkStatusReason == "Lead Created/Closed")
                  }
                  value={userData.mobileOne}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (userData.mobileOne.length < 10 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Mobile Number*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="mobileTwo"
                  name="mobileTwo"
                  maxLength="10"
                        pattern="[0-9]{10}"
                  disabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  style={{ background: "transparent" }}
                  value={userData.mobileTwo}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (userData.mobileTwo.length < 10 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Mobile Number 2
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="email"
                  name="email"
                  disabled={
                    !fieldsEditable ||
                    (ContactId && checkStatusReason == "Lead Created/Closed")
                  }
                  value={userData.email}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Email ID*
                </label>
              </div>

              {/* {console.log("selectDNCno :", selectDNCno)} */}
              <div className="select-container mt-2">
                <label className="select-search-label ">DNC Number</label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="selectDNCno"
                  placeholder="Select"
                  styles={style}
                  value={selectDNCno}
                  isSearchable={false}
                  onChange={handleSelectDNC}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  // style={{ background: "transparent" }}
                  options={optionDncNumber.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              {/* {console.log("selectLeadChannel",selectLeadChannel)} */}
              <div className="select-container mt-2">
                <label className="select-search-label">Lead Channel*</label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="leadChannel"
                  placeholder="Select"
                  styles={style}
                  value={selectLeadChannel} 
                  isSearchable={false}
                  onChange={handleSelectLead}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  options={optionLeadChannel.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">Lead Source*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="leadSource"
                  placeholder="Select Option"
                  styles={style}
                  isSearchable={false}
                  value={selectLeadSource}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  onChange={handleSelectLeadSource}
                  options={leadSourceOptions}
                />
              </div>

              {/* {selectLeadSource && selectLeadSource?.label?.includes("Other") ? (
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="specifyLeadSource"
                  name="specifyLeadSource"
                  value={userData.specifyLeadSource}
                  disabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  style={{ background: "transparent" }}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Specify Lead Source
                </label>
              </div>) : null} */}

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="campaignName"
                  name="campaignName"
                  value={userData.campaignName}
                  disabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  style={{ background: "transparent" }}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Campaign Name
                </label>
              </div>

              <div className="select-container mt-2">
                <label className="select-search-label">Product Category*</label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="Product"
                  placeholder="Select"
                  styles={style}
                  value={selectProductCategory}
                  isSearchable={false}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  onChange={handleSelectProductCategory}
                  options={optionProductCategory.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              {/* {console.log(
                "selectStatusReason.label",
                selectStatusReason
              )} */}
              <div className="select-container mt-2">
                <label className="select-search-label">Status Reason*</label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="Reason"
                  placeholder="Select"
                  styles={style}
                  value={selectStatusReason}
                  isSearchable={false}
                  onChange={handleSelectStatusReason}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  options={optionStatusReason.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>
              {/* {console.log("selectStatusReason",selectStatusReason)} */}

              {/* {console.log("selectedDateTime :",selectedDateTime)} */}
              {/* {selectStatusReason.label === "Scheduled for Appointment" && (
                <div className="select-container mt-2">
                  <label className="select-search-label">
                    Follow Up Date/Time
                  </label>
                  <DateTime
                    className=" datetime-picker mt-1"
                    styles={style}
                    value={selectedDateTime}
                    onChange={handleDateTimeChange}
                    dateFormat="DD-MM-YYYY"
                    timeFormat="HH:mm:ss"
                    inputProps={{ style: style.inputFocused }}
                  />
                </div>
              )} */}

              {/* dateTime picker calender */}
              {selectStatusReason.label === "Scheduled for Appointment" && (
              <div>
              <label className="select-search-label mt-1">Follow Up Date/Time</label>
              <StyledEngineProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["MobileDateTimePicker"]}>
                    <MobileDateTimePicker
                      value={selectedDateTime}
                      onChange={handleDateTimeChange}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </StyledEngineProvider>
              </div>)}
             
              {/* dateTime picker calender end */}

              {/* {console.log("Disposition",selectDisposition)} */}
              <div className="select-container mt-2">
                <label className="select-search-label">Disposition*</label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="Disposition"
                  placeholder="Select"
                  styles={style}
                  value={selectDisposition}
                  isSearchable={false}
                  onChange={handleSelectDisposition}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  options={optionDisposition.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="select-container mt-2">
                <label className="select-search-label">Competitor Name*</label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="CompetitorName"
                  placeholder="Select"
                  styles={style}
                  value={selectCompetitorName}
                  isSearchable={false}
                  onChange={handleSelectCompetitorName}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  options={optionCompetitorName.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              {/* {console.log(
                "selectIndustrySegment",
                selectIndustrySegment.value
              )} */}
              <div className="select-container mt-2">
                <label className="select-search-label">Industry Segment*</label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="industrySegment"
                  placeholder="Select"
                  styles={style}
                  value={selectIndustrySegment}
                  isSearchable={false}
                  onChange={handleSelectIndustrySegment}
                  options={optionIndustrySegment.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              {otpContactStatus === "111260000" ? null : (
                <div className="input-box form-floating mb-3">
                  <input
                    type="tel"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    maxLength="4"
                        pattern="[0-9]{10}"
                    id="otp"
                    name="otp"
                    value={userData.otp}
                    onChange={handleChange}
                    // onKeyDown={(e) => {
                    //   const allowedKeys = [
                    //     "Backspace",
                    //     "Delete",
                    //     "ArrowLeft",
                    //     "ArrowRight",
                    //     "Tab",
                    //   ];
                    //   const isDigit = /\d/.test(e.key);
                    //   if (
                    //     (isDigit || allowedKeys.includes(e.key)) &&
                    //     (userData.otp.length < 6 || e.key === "Backspace")
                    //   ) {
                    //     return true;
                    //   } else {
                    //     e.preventDefault();
                    //   }
                    // }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    OTP*
                  </label>
                </div>
              )}
            </form>
          </div>
        )}

        {/* **************PG Info toggle******************* */}
        {selectIndustrySegment && selectIndustrySegment.value === "PG" ? (
          <div
            className="Installation-toggle mt-3"
            onClick={() => handleIconClick("form2")}
          >
            <span className="toggle-text">PG Info</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>
        ) : null}

        {activeForm === "form2" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form2"
          >
            {/**********PG Info form******** */}
            <form className="contact-form pg-info-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgName"
                  name="pgName"
                  value={userData.pgName}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Name of the PG*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgOwner"
                  name="pgOwner"
                  value={userData.pgOwner}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PG Owner Name*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgContactNum"
                  name="pgContactNum"
                  // maxLength="10"
                        pattern="[0-9]{10}"
                  value={userData.pgContactNum}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) 
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PG Contact Number*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="howManyPg"
                  name="howManyPg"
                  // maxLength="10"
                        pattern="[0-9]{10}"
                  value={userData.howManyPg}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) 
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  How Many PG's Does this Owner have*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgAddress"
                  name="pgAddress"
                  value={userData.pgAddress}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PG Address with landmark*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgAreaName"
                  name="pgAreaName"
                  value={userData.pgAreaName}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Area Name(eg.Marathalli/Ecity/BTM..etc..)
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="NumOfPgFloor"
                  name="NumOfPgFloor"
                  value={userData.NumOfPgFloor}
                  onChange={handleChange}
                  // maxLength="5"
                        pattern="[0-9]{10}"
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) 
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Number of Floors in the PG*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="NumOfPgRoom"
                  name="NumOfPgRoom"
                  // maxLength="5"
                        pattern="[0-9]{10}"
                  value={userData.NumOfPgRoom}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) 
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Number of Rooms in the PG*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="NumOfPgBed"
                  name="NumOfPgBed"
                  // maxLength="10"
                        pattern="[0-9]{10}"
                  value={userData.NumOfPgBed}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) 
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Number of Beds in the PG*
                </label>
              </div>
              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="currentWifiOperator"
                  name="currentWifiOperator"
                  value={userData.currentWifiOperator}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Current Wifi Operator in the PG*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="NumOfPgBroadband"
                  name="NumOfPgBroadband"
                  // maxLength="10"
                        pattern="[0-9]{10}"
                  value={userData.NumOfPgBroadband}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) 
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Number of Broadband connections used*
                </label>
              </div>

                  {/* {console.log("selectPgWifiBill",selectPgWifiBill)} */}
              <div className="">
                <label className="select-search-label mt-1">
                  Average Monthly Spent on wifi bill*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select"
                  styles={style}
                  value={selectPgWifiBill}
                  isSearchable={false}
                  onChange={handleSelectWifiBill}
                  options={optionPgWifiBill.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="input-box form-floating">
                <input
                  type="date"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="dateOfRecharge"
                  name="dateOfRecharge"
                  value={userData.dateOfRecharge}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Date of Recharge of existing connections*
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Category of PG*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select"
                  styles={style}
                  value={selectPgCategory}
                  isSearchable={false}
                  onChange={handleSelectPgCategory}
                  options={optionPgCategory.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  CCTV Camera Available in the PG *
                </label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select"
                  styles={style}
                  value={selectPgCamera}
                  isSearchable={false}
                  onChange={handleSelectPgCamera}
                  options={optionPgCamera.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="serviceExpect"
                  name="serviceExpect"
                  value={userData.serviceExpect}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Service Expectations from the Operator*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="changeReason"
                  name="changeReason"
                  value={userData.changeReason}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Reason to Change the Current operator*
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Interested in Spectra PG Solution*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select"
                  styles={style}
                  value={selectPgSolution}
                  isSearchable={false}
                  onChange={handleSelectPgSolution}
                  options={optionPgSolution.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>
            </form>
          </div>
        )}

        {/* **************Installation Address toggle******************* */}
        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form3")}
        >
          <span className="toggle-text">Installation Address</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form3" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form3"
          >
            {/**********Installation Address form******** */}
            <form className="Installation-form p-2">
              <div className="">
                <label className="select-search-label mt-1">State*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="state"
                  placeholder="Select State"
                  isSearchable
                  styles={style}
                  value={selectState}
                  onChange={handleSelectState}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  options={optionState.map((data) => ({
                    value: data.code,
                    label: data.name,
                  }))}
                />
              </div>

              {/* {console.log("selectCity", selectCity)} */}
              <div className="">
                <label className="select-search-label mt-1">City*</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="City"
                  placeholder="Select City"
                  isSearchable
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  styles={style}
                  // value={cityType.find((city) => city.CityCode === selectCity.value)}
                  value={selectCity}
                  onChange={handleSelectCity}
                  options={cityType.map((data) => ({
                    value: data.CityCode,
                    label: data.CityName,
                  }))}
                />
              </div>

              <div className="search-area" style={{ position: "relative" }}>
                <label className="select-search-label mt-1">Area*</label>
                <Select
                  options={areaList.map((area) => ({
                    value: area.AreaCode,
                    label: `${area.AreaName} (${area.AreaCode})`,
                  }))}
                  className="basic-single form-control form-control-sm p-1 custom-select"
                  placeholder="Search Area"
                  styles={style}
                  isSearchable
                  value={selectArea}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  onChange={handleSelectArea}
                />
                <i
                  className="fas fa-search text-secondary"
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "63%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
              </div>

              {(selectArea && selectArea.label.includes("Other")) ? (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="specificArea"
                    name="specificArea"
                    value={userData.specificArea}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Specific Area Name
                  </label>
                </div>
              ) : null}

              <div className="search-building" style={{ position: "relative" }}>
                <label className="select-search-label mt-1">Building*</label>
                <Select
                  options={buildingList.map((building) => ({
                    value: building.BuildingCode,
                    label: `${building.BuildingName} (${building.BuildingCode})`,
                  }))}
                  className="basic-single form-control form-control-sm p-1 custom-select"
                  placeholder="Search Building"
                  styles={style}
                  isSearchable
                  value={selectBuilding}
                  isDisabled={
                    ContactId && checkStatusReason == "Lead Created/Closed"
                  }
                  onChange={(selectedOption) =>
                    setSelectBuilding(selectedOption)
                  }
                />
                <i
                  className="fas fa-search text-secondary"
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "63%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
              </div>

              {selectBuilding && selectBuilding.label.includes("Other") ? (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="specificBuilding"
                    name="specificBuilding"
                    value={userData.specificBuilding}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Specific Building Name
                  </label>
                </div>
              ) : null}
            </form>
          </div>
        )}

        {/* **************Remarks toggle******************* */}
        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form4")}
        >
          <span className="toggle-text">Remarks</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form4" && (
          <div
            className=" container shadow  mb-3 bg-body rounded mt-4"
            id="form4"
          >
            <form className="Remark-form p-2">

              <div className="remark-area">
                <label htmlFor="floatingInput">Remarks</label>
                <textarea
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm textarea"
                  id="remark"
                  name="remark"
                  value={userData.remark}
                  onChange={handleChange}
                />
                {/* <label htmlFor="floatingInput" className="mt-2">
                  Remarks*
                </label> */}
              </div>

            </form>
          </div>
        )}

        {otpSent ? (
          otpContactStatus !== "111260000" ? (
            <div className="row">
              <div className="col-6">
                <div className="text-center mt-5">
                  <button
                    type="submit"
                    className="btn text-light bg-dark mx-auto rounded-pill btn-verify_otp"
                    onClick={() =>
                      handleResendOtp(userData.email, userData.mobileOne)
                    }
                  >
                    Resend OTP
                  </button>
                </div>
              </div>
              <div className="col-6">
                <div className="text-center mt-5">
                  <button
                    type="submit"
                    className="btn text-light bg-dark mx-auto rounded-pill btn-resend_otp"
                    onClick={handleVerifyOtp}
                  >
                    Submit OTP
                  </button>
                </div>
              </div>
            </div>
          ) : null
        ) : (
          <div className="text-center mt-5 mb-3">
            <button
              type="submit"
              className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
              onClick={() => handleSendOtp(userData.email, userData.mobileOne)}
            >
              Send OTP
            </button>
          </div>
        )}

        {checkStatusReason == "Lead Created/Closed" ? null : (
          <div className="text-center mt-5 mb-5">
            <button
              type="submit"
              className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
              onClick={handleSubmit}
              // disabled={ otpContactStatus !== "111260000" && !ContactId }
            >
              Save
            </button> 
          </div>
        )}
      </div> 
    </>
  );
};

export default ContactsManagementForm;
